import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        openButton: {
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            width: remCalc(101),
            height: remCalc(36),
            borderRadius: remCalc(18),
            _before: {
                content: '""',
                position: 'absolute',
                bg: 'background.light-blue',
                inset: 0,
                opacity: 0.2,
                borderRadius: remCalc(18),
            },
        },
        selectorSubContainer: {
            zIndex: 1,
            height: 'auto',
        },
        countrySvgContainer: {
            width: remCalc(20),
            height: remCalc(20),
            borderRadius: '50%',
            overflow: 'hidden',
            justifyContent: 'center',
            alignItems: 'center',
        },
        buttonText: {
            color: 'text.inverse',
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        buttonArrow: {
            boxSize: 'iconsSize.small',
            color: 'white',
        },
        modalContainer: {
            size: 'full',
            display: 'flex',
            flexDir: 'column',
            alingItems: 'flex-start',
            gap: remCalc(10),
        },
        modalBody: {
            paddingY: {base: remCalc(24), md: remCalc(42), lg: remCalc(48), xl: remCalc(42)},
            paddingX: 0,
            display: 'flex',
            flexDir: 'column',
            alingItems: 'flex-start',
            gap: remCalc(42),
        },
        selectorContent: {
            paddingX: {
                xl: remCalc(260),
                lg: remCalc(24),
                md: remCalc(24),
                base: remCalc(16),
            },
        },
        selectorHeader: {
            display: 'flex',
            flexDir: 'column',
            alingItems: 'flex-start',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            paddingX: 0,
        },
        headerText: {
            alignSelf: 'flex-start',
            textStyle: 'head-xlarge',
            fontWeight: 'medium',
        },
        closeIconContainer: {
            display: 'flex',
            width: 'iconsSize.xlarge',
            height: 'iconsSize.xlarge',
            paddingY: remCalc(8),
            marginLeft: 'auto',
            justifyContent: 'center',
            alignItems: 'center',
            flexShrink: 0,
        },
        closeIcon: {
            h: remCalc(40),
            w: remCalc(40),
        },
        countryContainer: {
            w: 'auto',
            height: 'auto',
            display: 'flex',
            flexDir: 'row',
            gap: remCalc(16),
            alignItems: 'center',
        },
        region: {
            display: 'flex',
            flexDir: 'column',
            justifyContent: 'flex-start',
            paddingX: 0,
            borderBottom: {sm: 'none', lg: 'small'},
            borderStyle: 'solid',
            borderColor: 'border.light !important',
        },
        flag: {
            width: remCalc(36),
            height: remCalc(27),
            flexShrink: '0',
        },
        textHeader: {
            color: 'text.default',
            textStyle: {base: 'head-xsmall', lg: 'head-medium'},
            fontWeight: 'medium',
        },
        textFooterHeader: {
            color: 'text.default',
            textStyle: 'head-medium',
            fontWeight: 'medium',
        },
        textCountry: {
            color: 'text.secondary',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        textCode: {
            color: 'text.default',
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        selectorGrid: {
            marginY: {base: remCalc(24), lg: remCalc(64)},
            gridTemplateColumns: {
                base: `repeat(1, minmax(${remCalc(226)}, 1fr))`,
                md: `repeat(4, minmax(${remCalc(226)}, 1fr))`,
            },
            spacingX: remCalc(25),
            spacingY: remCalc(42),
            //minChildWidth: remCalc(226),
        },
        selectorFooter: {
            paddingY: remCalc(24),
            paddingX: 0,
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'flex-start',
            alingItems: 'flex-start',
            gap: remCalc(16),
        },
        footerContent: {
            display: 'flex',
            width: remCalc(331),
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: remCalc(28),
        },
        footerText: {
            color: 'text.secondary',
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        accordionItem: {
            borderTop: 'none',
            borderBottomWidth: remCalc(0.5),
            padding: remCalc(24),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        accordionButton: {
            alignItems: 'center',
        },
        accordionIcon: {
            color: 'background.dark',
            boxSize: 'iconsSize.large',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        websiteIcon: {
            color: 'text.inverse',
        },
    },
}
